import APIClient from './APIClient';
import { PromoCodeReportInterface, ReportInterface } from 'types';

export type DateFilter = {
    month: string;
    year: string;
};

class ReportsService {
    getReports(
        spotPk: number,
        filters: { date: { month: number; year: number } } | undefined,
        token: string
    ): Promise<ReportInterface> {
        let reportRequest = `reports/reports?spot=${spotPk}`;
        if (filters) {
            reportRequest += `&month=${filters.date.month}&year=${filters.date.year}`;
        }
        return APIClient.get(reportRequest, token);
    }

    getPromoCodeReports(
        spotPk: number,
        filters: { date: DateFilter },
        token: string
    ): Promise<PromoCodeReportInterface> {
        let reportRequest = `reports/promocodes?spot=${spotPk}`;
        if (filters) {
            reportRequest += `&month=${filters.date.month}&year=${filters.date.year}`;
        }
        return APIClient.get(reportRequest, token);
    }
}

export default new ReportsService();
